import API from './Api'

class FileApi {
  async AddFile(model: FormData) {
    return await API.post('e/Files',
      model, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  }
}

export default new FileApi()
